import React from 'react';
import { Clock, ChevronRight } from 'lucide-react';

/**
 * Current Dasha Card — top widget showing the 5-level active dasha.
 * Each row clickable to open DashaPopup.
 *
 * Props:
 *   - vimshottari: data.vimshottari from kundli API
 *   - onClickLevel: (levelObj, levelName) => void
 */

const LEVEL_LABELS = {
  mahadasha: { en: 'Mahadasha', hi: 'महादशा', short: 'MD' },
  antardasha: { en: 'Antardasha', hi: 'अंतर्दशा', short: 'AD' },
  pratyantardasha: { en: 'Pratyantardasha', hi: 'प्रत्यंतर्दशा', short: 'PD' },
  sookshma: { en: 'Sookshma', hi: 'सूक्ष्म', short: 'SD' },
  prana: { en: 'Prana', hi: 'प्राण', short: 'PrD' },
};

const LEVEL_ORDER = ['mahadasha', 'antardasha', 'pratyantardasha', 'sookshma', 'prana'];

export default function CurrentDashaCard({ vimshottari, onClickLevel }) {
  if (!vimshottari || !vimshottari.current) return null;
  const cur = vimshottari.current;
  const birth = vimshottari.birth_dasha || {};

  return (
    <div data-testid="current-dasha-card" className="rounded-2xl border border-gold/40 bg-gradient-to-br from-purple-900/60 via-purple-950/40 to-bg-primary p-5 shadow-xl">
      <div className="flex items-center justify-between mb-4 flex-wrap gap-2">
        <div className="flex items-center gap-2">
          <Clock className="w-5 h-5 text-gold" />
          <h3 className="font-heading text-lg text-gold">वर्तमान दशा (Current Dasha)</h3>
        </div>
        <div className="text-xs text-text-muted">
          जन्म नक्षत्र · <span className="text-gold">{vimshottari?.birth_dasha?.lord_hi}</span> · पाद {birth.pada} · बैलेंस {birth.balance_dms}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-5 gap-2">
        {LEVEL_ORDER.map((lv) => {
          const d = cur[lv];
          const label = LEVEL_LABELS[lv];
          if (!d) {
            return (
              <div key={lv} className="rounded-xl border border-white/5 bg-white/[0.02] p-3 opacity-40">
                <div className="text-[10px] uppercase tracking-wider text-text-muted">{label.short} · {label.hi}</div>
                <div className="text-sm text-text-muted mt-1">—</div>
              </div>
            );
          }
          return (
            <button
              key={lv}
              data-testid={`current-${lv}`}
              onClick={() => onClickLevel && onClickLevel(d, lv)}
              className="text-left rounded-xl border border-gold/30 bg-gradient-to-br from-gold/15 to-gold/5 p-3 hover:from-gold/25 hover:to-gold/10 transition-all"
            >
              <div className="text-[10px] uppercase tracking-wider text-gold/80">{label.short} · {label.hi}</div>
              <div className="text-base font-heading text-gold mt-1">{d.lord_hi}</div>
              <div className="text-[11px] text-text-muted mt-1 font-mono">शेष: {d.remaining_str}</div>
              <ChevronRight className="w-3 h-3 text-gold/50 mt-1" />
            </button>
          );
        })}
      </div>
    </div>
  );
}
